import { Autocomplete, Stack, TextField } from '@mui/material'
import { JobBoardNotInterestedReasons } from '__generated__/graphql'
import { FormikProps } from 'formik'
import { FC } from 'react'
import { JobBoardFormValues } from '.'

interface NotInterestedFormFieldsProps {
    formik: FormikProps<JobBoardFormValues>
    canEdit: boolean
}

export function getNotInterestedReasonLabels(
    reason: JobBoardNotInterestedReasons
): string {
    switch (reason) {
        case JobBoardNotInterestedReasons.Locations:
            return 'Locations do not work for me'
        case JobBoardNotInterestedReasons.Sectors:
            return 'Sectors do not work for me'
        case JobBoardNotInterestedReasons.NotLooking:
            return 'Not currently looking for new opportunities'
        case JobBoardNotInterestedReasons.Other:
            return 'Other'
        case JobBoardNotInterestedReasons.Positions:
            return 'Positions do not work for me'
        default:
            return reason
    }
}

const NotInterestedFormFields: FC<NotInterestedFormFieldsProps> = ({
    formik,
    canEdit,
}) => {
    return (
        <Stack gap={2} marginTop={2}>
            <Autocomplete
                disabled={formik.values.disabled || !canEdit}
                fullWidth
                ChipProps={{ size: 'small' }}
                options={Object.values(JobBoardNotInterestedReasons)}
                getOptionLabel={(option) =>
                    getNotInterestedReasonLabels(option)
                }
                value={formik.values.notInterestedReason}
                onChange={(event, newValue) => {
                    formik.setFieldValue('notInterestedReason', newValue)
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Could you tell us why you aren't interested?"
                        variant="outlined"
                        required
                        error={
                            formik.touched.notInterestedReason &&
                            Boolean(formik.errors.notInterestedReason)
                        }
                        helperText={
                            formik.touched.notInterestedReason &&
                            formik.errors.notInterestedReason
                        }
                    />
                )}
            />
            <TextField
                disabled={formik.values.disabled || !canEdit}
                id="comments"
                label="Additional Comments"
                value={formik.values.notInterestedComments}
                multiline
                rows={6}
                onChange={(e) =>
                    formik.setFieldValue(
                        'notInterestedComments',
                        e.target.value
                    )
                }
            />
        </Stack>
    )
}

export default NotInterestedFormFields
